import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
const UpgradeCertificateBanner = ({ classes }) => {
  return (
    <div className={classes.certificationContainer}>
      <div className={classes.header}>
        <Typography className={classes.title}>Certification</Typography>
        <Typography className={classes.description}>
          Award learners a digital certificate when they complete a learning path
          or pass the success threshold.
        </Typography>
      </div>
      <div className={classes.content}>
        <div className={classes.bannerContainer}>
          <div className={classes.bannerContent}>
            <Typography className={classes.bannerText}>
              Want to Certificate your learners?
            </Typography>
            <Typography className={classes.bannerSubText}>
              On our paid plans, you can set a certificate of completion or
              success, based on a success rate threshold you determine. Check
              details at the button below!
            </Typography>
            <CoreButton
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                window.location.href = '/pricing'
              }}
            >
              See Plans & Upgrade
            </CoreButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(UpgradeCertificateBanner)
